import { CreateButton as ReactAdminCreateButton, CreateButtonProps } from 'react-admin'

export const CreateButton = (props: CreateButtonProps): JSX.Element => {
  return <ReactAdminCreateButton {...props} size='medium' />
}
